import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FiArrowRight as ArrowRight,
  FiArrowUpRight as ArrowUpRight,
  FiBarChart2 as BarChart3,
  FiBookOpen as BookOpenCheck,
  FiCheck as Check,
  FiChevronRight as ChevronRight,
  FiHelpCircle as CircleHelp,
  FiCompass as Compass,
  FiHome as Landmark,
  FiLayers as Layers3,
  FiMenu as Menu,
  FiShield as ShieldCheck,
  FiX as X,
} from 'react-icons/fi';
import { Loading } from '../../components';
import customer from '../../assets/customer.jpg';
import customer1 from '../../assets/customer1.jpg';
import './Home.css';

const navigation = [
  { label: 'About', href: '/about' },
  { label: 'Markets', href: '/exchange' },
  { label: 'Proof of reserve', href: '/proof-of-reserve' },
];

export function BrandWordmark() {
  return (
    <span className="brand-wordmark">
      <span className="brand-mark" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none">
          <path d="m6 22 7-7 5 4 8-10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20 9h6v6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className="brand-name">Profit<span>Growing</span></span>
    </span>
  );
}

function MarketPreview() {
  return (
    <div className="market-panel" aria-label="Illustrative platform market overview">
      <div className="panel-heading">
        <div>
          <div className="panel-label">Market overview</div>
          <div className="panel-value">A clearer market picture</div>
        </div>
        <div className="panel-change">
          PLATFORM PREVIEW
          <strong>Illustrative view</strong>
        </div>
      </div>
      <div className="chart-wrap">
        <svg viewBox="0 0 560 190" role="img" aria-label="Decorative sample market chart">
          <defs>
            <linearGradient id="chart-fill" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#5367e8" stopOpacity=".2" />
              <stop offset="100%" stopColor="#5367e8" stopOpacity="0" />
            </linearGradient>
          </defs>
          {[25, 68, 111, 154].map((y) => (
            <line key={y} className="chart-gridline" x1="0" x2="560" y1={y} y2={y} />
          ))}
          <path
            className="chart-area"
            d="M0 137 C28 130 36 145 62 127 S100 119 122 126 S157 109 180 115 S205 92 230 101 S259 92 281 99 S313 78 339 86 S374 68 394 80 S424 55 447 66 S472 43 492 56 S531 33 560 39 L560 190 L0 190Z"
          />
          <path
            className="chart-line"
            d="M0 137 C28 130 36 145 62 127 S100 119 122 126 S157 109 180 115 S205 92 230 101 S259 92 281 99 S313 78 339 86 S374 68 394 80 S424 55 447 66 S472 43 492 56 S531 33 560 39"
          />
          <circle className="chart-dot" cx="447" cy="66" r="5" />
        </svg>
        <div className="chart-tooltip">Market movement · sample</div>
      </div>
      <div className="axis-row">
        <span>ASSET ACTIVITY</span>
        <span>Explore market information</span>
        <span>OVERVIEW</span>
      </div>
      <div className="asset-strip">
        <div className="asset-mini">
          <span className="coin-mark coin-btc">B</span>
          <span><b>Bitcoin</b><small>Market overview</small></span>
        </div>
        <div className="asset-mini">
          <span className="coin-mark coin-eth">E</span>
          <span><b>Ethereum</b><small>Market overview</small></span>
        </div>
        <div className="asset-mini">
          <span className="coin-mark coin-sol">S</span>
          <span><b>Digital assets</b><small>Explore markets</small></span>
        </div>
      </div>
    </div>
  );
}

function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);


  return (
    <main className="home-root">
      <header className="site-header">
        <div className="home-container header-row">
          <Link to="/" className="brand-link" aria-label="ProfitGrowing home" onClick={closeMenu}>
            <BrandWordmark />
          </Link>
          <nav className={`main-nav${menuOpen ? ' is-open' : ''}`} aria-label="Main navigation">
            {navigation.map((item) => (
              <Link key={item.href} to={item.href} onClick={closeMenu}>{item.label}</Link>
            ))}
            <div className="mobile-account-links">
              <Link to="/auth/login" onClick={closeMenu}>Log in</Link>
              <Link className="nav-cta" to="/auth/register" onClick={closeMenu}>Create account</Link>
            </div>
          </nav>
          <div className="header-actions">
            <Link to="/auth/login">Log in</Link>
            <Link className="nav-cta" to="/auth/register">Create account <ArrowUpRight size={14} /></Link>
          </div>
          <button
            type="button"
            className="mobile-toggle"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            data-testid="button-mobile-menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <X size={19} /> : <Menu size={19} />}
          </button>
        </div>
      </header>

      <section className="hero">
        <div className="home-container hero-grid">
          <div className="hero-content">
            <div className="eyebrow">A considered view of digital assets</div>
            <h1>Markets move.<br /><span>Stay in control.</span></h1>
            <p className="hero-copy">
              Explore crypto markets and manage investment-related accounts in one place.
              Clear information, useful tools, and room to make your own decisions.
            </p>
            <div className="hero-actions">
              <Link className="button-primary" to="/auth/register">
                Create your account <ArrowRight size={15} />
              </Link>
              <Link className="button-ghost" to="/exchange">
                Explore markets <ArrowUpRight size={14} />
              </Link>
            </div>
            <p className="hero-note">Digital assets involve risk. Values can change quickly.</p>
          </div>
          <MarketPreview />
        </div>
      </section>

      <div className="ticker-bar" aria-label="Explore platform areas">
        <div className="home-container ticker-inner">
          <span className="ticker-label">Explore</span>
          <Link className="ticker-item" to="/exchange">
            <span className="ticker-symbol"><BarChart3 size={12} /></span><b>Markets</b><em>Discover</em>
          </Link>
          <Link className="ticker-item" to="/proof-of-reserve">
            <span className="ticker-symbol"><ShieldCheck size={12} /></span><b>Proof of reserve</b><em>Review</em>
          </Link>
          <Link className="ticker-item" to="/about">
            <span className="ticker-symbol"><CircleHelp size={12} /></span><b>About us</b><em>Learn</em>
          </Link>
          <span className="ticker-disclaimer">Explore at your own pace</span>
        </div>
      </div>

      <section className="section" id="approach">
        <div className="home-container overview-layout">
          <div className="overview-side">
            <div className="section-kicker">One place, more perspective</div>
            <h2 className="section-heading">A more considered way to navigate crypto.</h2>
            <p className="section-intro">
              Digital-asset information can be fragmented. ProfitGrowing brings
              market exploration and investment-related account tools together in a
              straightforward experience.
            </p>
            <Link className="text-link" to="/about">Get to know us <ArrowRight size={15} /></Link>
          </div>
          <div className="capability-list">
            <article className="capability-row">
              <span className="capability-number">01</span>
              <div><h3>Explore with context</h3><p>Find a clearer starting point for exploring crypto markets and digital-asset information.</p></div>
              <Compass className="capability-icon" size={19} strokeWidth={1.7} />
            </article>
            <article className="capability-row">
              <span className="capability-number">02</span>
              <div><h3>Keep account details close</h3><p>Bring investment-related account management into the same considered experience.</p></div>
              <Layers3 className="capability-icon" size={19} strokeWidth={1.7} />
            </article>
            <article className="capability-row">
              <span className="capability-number">03</span>
              <div><h3>Know where to look</h3><p>Navigate directly to market access, company information, and reserve disclosures.</p></div>
              <BookOpenCheck className="capability-icon" size={19} strokeWidth={1.7} />
            </article>
          </div>
        </div>
      </section>

      <section className="market-section" id="markets">
        <div className="home-container">
          <div className="market-head">
            <div>
              <div className="section-kicker">Make your next move your own</div>
              <h2 className="section-heading">Start with what<br />you want to understand.</h2>
            </div>
            <p className="section-intro">Browse the areas of the platform that help you find your footing. No predictions, just a place to explore.</p>
          </div>
          <div className="market-grid">
            <article className="market-feature">
              <div className="feature-topline">01 / Market access</div>
              <div>
                <h3>Explore digital-asset markets on your terms.</h3>
                <p>Visit the exchange area to learn more about the available market experience and decide where you want to go next.</p>
              </div>
              <Link className="text-link" to="/exchange">Visit exchange <ArrowRight size={15} /></Link>
              <div className="feature-orbit" aria-hidden="true"><BarChart3 size={30} strokeWidth={1.2} /></div>
            </article>
            <div className="market-aside">
              <article className="market-card">
                <span className="card-icon"><ShieldCheck size={18} /></span>
                <div><h3>Reserve information</h3><p>Review the proof-of-reserve information available on the platform.</p></div>
                <Link className="text-link" to="/proof-of-reserve">View disclosures <ChevronRight size={14} /></Link>
              </article>
              <article className="market-card">
                <span className="card-icon"><Landmark size={18} /></span>
                <div><h3>About ProfitGrowing</h3><p>Understand the platform and its approach to digital-asset tools.</p></div>
                <Link className="text-link" to="/about">Learn about us <ChevronRight size={14} /></Link>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section className="proof-section" id="transparency">
        <div className="home-container proof-grid">
          <div className="proof-visual" aria-hidden="true">
            <div className="proof-ring">
              <div className="proof-center"><ShieldCheck size={31} strokeWidth={1.5} /></div>
              <div className="orbit-node node-one"><Check size={15} /></div>
              <div className="orbit-node node-two"><BookOpenCheck size={14} /></div>
              <div className="orbit-node node-three"><BarChart3 size={14} /></div>
            </div>
          </div>
          <div className="proof-copy">
            <div className="section-kicker">Transparency matters</div>
            <h2 className="section-heading">Make space for the details.</h2>
            <p className="section-intro">
              Digital-asset platforms should make relevant information easier to find.
              Our proof-of-reserve area is a place to review the disclosures provided
              about reserves.
            </p>
            <div className="proof-points">
              <div className="proof-point"><Check size={15} /><span><strong>Direct access.</strong> Go straight to the platform's reserve information.</span></div>
              <div className="proof-point"><Check size={15} /><span><strong>Read for yourself.</strong> Review the available disclosures and their scope.</span></div>
              <div className="proof-point"><Check size={15} /><span><strong>Keep perspective.</strong> Disclosures do not remove the risks of digital assets.</span></div>
            </div>
            <Link className="text-link" to="/proof-of-reserve">Visit proof of reserve <ArrowRight size={15} /></Link>
          </div>
        </div>
      </section>

      <section className="account-band" id="accounts">
        <div className="home-container account-layout">
          <div>
            <div className="section-kicker">Built around clarity</div>
            <h2 className="section-heading">Useful tools.<br />Your decisions.</h2>
            <p className="section-intro">A practical platform for people who want fewer detours between understanding the market and managing their account.</p>
            <Link className="text-link" to="/auth/register">Get started <ArrowRight size={15} /></Link>
          </div>
          <div className="account-cards">
            <article className="account-card">
              <Compass size={21} strokeWidth={1.6} />
              <div><h3>Discover markets</h3><p>Explore digital-asset market information through the exchange area.</p></div>
            </article>
            <article className="account-card">
              <Layers3 size={21} strokeWidth={1.6} />
              <div><h3>Manage in one place</h3><p>Access investment-related account tools through a single platform.</p></div>
            </article>
            <article className="account-card">
              <ShieldCheck size={21} strokeWidth={1.6} />
              <div><h3>Review disclosures</h3><p>Find reserve information and understand what is being disclosed.</p></div>
            </article>
            <article className="account-card">
              <CircleHelp size={21} strokeWidth={1.6} />
              <div><h3>Know the platform</h3><p>Get acquainted with ProfitGrowing before deciding what to do.</p></div>
            </article>
          </div>
        </div>
      </section>

      <section id="testimonials" className="testimonial-section" aria-labelledby="testimonials-heading">
        <div className="home-container">
          <div className="testimonial-heading">
            <div className="section-kicker">Customer stories</div>
            <h2 className="section-heading" id="testimonials-heading">What People Are Saying</h2>
            <p className="section-intro">We are trusted by thousands of users across the globe.</p>
          </div>
          <div className="testimonial-grid">
            <article className="testimonial-card">
              <span className="testimonial-quote-mark" aria-hidden="true">“</span>
              <blockquote>
                I want to say a big thank you to ProfitGrowing. Just got my profit of $7500 in my Bank account. This is indeed a trust worthy platform to invest
              </blockquote>
              <div className="testimonial-person">
                <img className="testimonial-avatar" src={customer} alt="" />
                <div><strong>Carly Jones</strong><span>Verified Client</span></div>
              </div>
            </article>
            <article className="testimonial-card">
              <span className="testimonial-quote-mark" aria-hidden="true">“</span>
              <blockquote>
                It's really wonderful. I would also like to say thank you to all your staff. ProfitGrowing did exactly what you said it does.
              </blockquote>
              <div className="testimonial-person">
                <img className="testimonial-avatar" src={customer1} alt="" />
                <div><strong>Cynthia Jones</strong><span>Verified Client</span></div>
              </div>
            </article>
          </div>
          <p className="testimonial-disclaimer">Testimonials reflect individual experiences and do not guarantee future results. Digital assets involve risk.</p>
        </div>
      </section>

      <section className="closing">
        <div className="home-container closing-inner">
          <div>
            <div className="eyebrow">Take a closer look</div>
            <h2>Explore first. Decide with care.</h2>
            <p>See what the platform offers, then choose your next step.</p>
          </div>
          <Link className="button-primary" to="/exchange">Explore the platform <ArrowUpRight size={15} /></Link>
        </div>
      </section>

      <footer className="site-footer">
        <div className="home-container">
          <div className="footer-main">
            <div className="footer-brand">
              <Link to="/" className="brand-link" aria-label="ProfitGrowing home">
                <BrandWordmark />
              </Link>
              <p>A digital-asset platform for exploring crypto markets and managing investment-related accounts with clarity and control.</p>
            </div>
            <div className="footer-col">
              <h4>Explore</h4>
              <Link to="/exchange">Markets</Link>
              <Link to="/proof-of-reserve">Proof of reserve</Link>
              <Link to="/about">About</Link>
            </div>
            <div className="footer-col">
              <h4>Your account</h4>
              <Link to="/auth/login">Log in</Link>
              <Link to="/auth/register">Create account</Link>
            </div>
            <div className="footer-col">
              <h4>Platform</h4>
              <Link to="/about">Our approach</Link>
              <Link to="/proof-of-reserve">Disclosures</Link>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="risk-disclosure">
              Digital assets are volatile and involve a high degree of risk. You may lose some or all of your investment. Information on this site is for general purposes and is not investment advice.
            </div>
            <div className="footer-legal">© {new Date().getFullYear()} ProfitGrowing</div>
          </div>
        </div>
      </footer>
    </main>
  );
}

export default Loading(Home);